import type { FetchError } from '../../utils/UseCustomInstance';
import type { Pillar2BffRequest } from './executePillar2Filing';
import { getJurisdictionBasePath, Pillar2Jurisdiction } from './pillar2Jurisdictions';

export async function fetchPillar2AuthStatus(bff: Pillar2BffRequest, jurisdiction: Pillar2Jurisdiction): Promise<boolean> {
    if (jurisdiction !== 'GB') return true; // Non-UK don't use OAuth
    const basePath = getJurisdictionBasePath(jurisdiction);
    const data = (await bff({ url: `${basePath}/auth/status`, method: 'get' })) as { authenticated?: boolean };
    return data?.authenticated === true;
}

export async function postPillar2AuthLogout(bff: Pillar2BffRequest, jurisdiction: Pillar2Jurisdiction): Promise<void> {
    if (jurisdiction !== 'GB') return;
    const basePath = getJurisdictionBasePath(jurisdiction);
    await bff({ url: `${basePath}/auth/logout`, method: 'post' });
}

export function isFetchUnauthorized(err: unknown): boolean {
    if (!err || typeof err !== 'object' || !('response' in err)) {
        return false;
    }
    const status = (err as FetchError).response?.status;
    return status === 401;
}
